/** ==========================================================
 * Diretiva para permitir inserir somente números em um input
 * =========================================================== */
const validateCharacters = (e) => {
  if (e.key.search(/[^0-9]+/g) > -1) {
    e.preventDefault()
    return false
  }

  return true
}

const OnlyNumbersDirective = {
  bind(el) {
    const input = el.querySelector('input')

    input.addEventListener('keypress', validateCharacters)
  },

  unbind(el) {
    el.querySelector('input').removeEventListener(
      'keypress',
      validateCharacters
    )
  }
}

export default OnlyNumbersDirective
